// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style-module--contentWrapper--szqJc","infoRow":"style-module--infoRow--D6acC"};